import $ from 'jquery';

(($, Drupal) => {
  const initCookieBanner = (el) => {
    const $document = $(el);

    const config = { attributes: true, childList: true, subtree: true };

    const callback = (mutationList) => {
      mutationList.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'data-eu-cookie-compliance-once'
        ) {
          const openSettingsButton = $('#cookie-settings');
          openSettingsButton.on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            $('.cookie-settings').addClass('expanded');
          });
        }
      });
    };

    const observer = new MutationObserver(callback);

    observer.observe($(el).get(0), config);
  };

  Drupal.behaviors.furuboda_cookie = {
    attach: (context) => {
      initCookieBanner($(document), context);
    },
  };
})(jQuery, Drupal);
